import { Card, CardContent, CardMedia, Typography, useTheme } from '@mui/material';

import { SvgColor } from '../svg-color';
import {
  ContainerCardStyled,
  IconBackgroundStyled,
  IconBackgroundLayerStyled,
  TitleBackgroundStyled,
  RatingFieldStyled,
} from './styles';

interface Props {
  title?: string;
  height?: string | number;
  width?: Record<string, string | number>;
  ratingData?: string[];
  ratingIconImg?: string;
}

const ReviewDetailsCard = ({ title, height, width, ratingData, ratingIconImg }: Props) => {
  const theme = useTheme();
  return (
    <Card sx={{ height, width, borderRadius: '8px' }}>
      {title && (
        <TitleBackgroundStyled>
          <Typography
            fontWeight={700}
            fontSize={12}
            sx={{
              padding: '3px',
              textAlign: 'center',
            }}
          >
            {title}
          </Typography>
        </TitleBackgroundStyled>
      )}
      {ratingData && (
        <ContainerCardStyled>
          <CardContent>
            {ratingData.map((field: any, index: any) => (
              <RatingFieldStyled key={index}>{field}</RatingFieldStyled>
            ))}
          </CardContent>
          <CardMedia sx={{ display: 'flex', justifyContent: 'center', direction: 'row' }}>
            <IconBackgroundLayerStyled>
              <IconBackgroundStyled>
                <SvgColor
                  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                  src={`/assets/icons/card/${ratingIconImg}.svg`}
                  sx={{
                    width: '20px',
                    height: '20px',
                    color: theme.palette.common.white,
                    alignSelf: 'center',
                  }}
                />
              </IconBackgroundStyled>
            </IconBackgroundLayerStyled>
          </CardMedia>
        </ContainerCardStyled>
      )}
    </Card>
  );
};

export { ReviewDetailsCard };
